import { FocusEvent, Ref, forwardRef, useRef } from 'react';
import { EpInputProps, setIconSize } from '.';
import { EpIcon } from '../EpIcon';
import './EpInput.scss';

// eslint-disable-next-line @typescript-eslint/no-var-requires
// const intlTelInput = require('intl-tel-input');

export const EpInput = forwardRef(function EpInput(
  {
    inputId,
    inputType = 'text',
    inputName,
    inputValue,
    inputAutocomplete = 'off',
    inputAriaDescribedby,
    inputSize,
    inputMaxValue,
    inputMinValue,
    inputMaxLength,
    inputMinLength,
    inputWidth = 300,
    inputAddonLeftText,
    inputAddonRightText,
    inputIsFullWidth = false,
    inputIsDisabled = false,
    inputWithError = false,
    inputPlaceholder = '',
    inputHasIcon = false,
    inputIconName = '',
    inputOnFocusFunc,
    customClasses,
    ...props
  }: EpInputProps,
  ref: Ref<HTMLInputElement>,
) {
  const epInputRef = useRef<HTMLDivElement>(null);
  const hasIcon: boolean =
    inputHasIcon &&
    inputType !== 'tel' &&
    !inputAddonLeftText &&
    !inputAddonRightText;

  // useEffect(() => {
  //   formatTelephoneInput();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // const formatTelephoneInput = () => {
  //   if (inputType !== 'tel') return;

  //   const phoneInputField = document.querySelector(`#${inputId}`) as
  //     | HTMLElement
  //     | HTMLInputElement;
  //   let isValidDigit: boolean;
  //   // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //   const inputTelConfigs: any = {
  //     formatOnDisplay: true,
  //     separateDialCode: true,
  //     preferredCountries: ['br'],
  //     utilsScript:
  //       'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
  //   };

  //   if (inputPlaceholder === '') {
  //     inputTelConfigs.autoPlaceholder = 'aggressive';
  //   } else {
  //     inputTelConfigs.customPlaceholder = inputPlaceholder;
  //   }

  //   const intlTelInputInstance = intlTelInput(phoneInputField, inputTelConfigs);

  //   const setTelephoneWithDDDDataAttribute = () => {
  //     const currentInput =
  //       window.intlTelInputGlobals.getInstance(phoneInputField);
  //     const telephoneNumber = currentInput.getNumber(1).toString();

  //     phoneInputField.setAttribute('data-tel-with-ddd', telephoneNumber);
  //   };

  //   phoneInputField.addEventListener('click', function () {
  //     setTelephoneWithDDDDataAttribute();
  //   });

  //   phoneInputField.addEventListener('countrychange', function () {
  //     intlTelInputInstance.setNumber('');
  //     setTelephoneWithDDDDataAttribute();
  //   });

  //   phoneInputField.addEventListener('keypress', (event: Event) => {
  //     const isTypingNumber = checkIsTypingNumber(event);

  //     if (!isTypingNumber) {
  //       event.preventDefault();
  //       isValidDigit = false;
  //       return;
  //     }

  //     isValidDigit = true;
  //   });

  //   phoneInputField.addEventListener('keyup', function () {
  //     if (!isValidDigit) return;

  //     setTelephoneWithDDDDataAttribute();
  //   });

  //   phoneInputField.addEventListener('keyup', (event: Event) => {
  //     const eventTarget = event.target as HTMLInputElement;

  //     intlTelInputInstance.setNumber(eventTarget.value);

  //     if (intlTelInputInstance.isValidNumber()) {
  //       phoneInputField.setAttribute(
  //         'maxlength',
  //         eventTarget.value.length.toString(),
  //       );
  //     }
  //   });
  // };

  //TODO: Trocar a classe "ep-input--with-focus" por "focus-ring" quando o bootstrap for atualizado
  const handleInputFocus = ({ target }: FocusEvent<HTMLInputElement>): void => {
    if (inputWithError || inputIsDisabled) return;
    const inputCurrent = epInputRef.current;
    if (!inputCurrent) return;

    inputCurrent.classList.add('ep-input--with-focus');
    target.addEventListener('blur', () => inputCurrent.classList.remove('ep-input--with-focus'),
    );
  };

  return (
    <div
      {...(inputIsFullWidth
        ? { style: { width: '100%' } }
        : { style: { width: `${inputWidth}px` } })}
    >
      <div
        ref={epInputRef}
        className={`
          form-control ep-input
          ep-input--${inputSize}
          ${inputType === 'tel' ? 'ep-input--is-telephone' : ''}
          ${inputIsFullWidth ? 'ep-input--is-full-width' : ''}
          ${inputWithError ? 'ep-input--with-error' : ''}
          ${hasIcon ? 'ep-input--has-icon' : ''}
          ${inputAddonLeftText ? 'ep-input--addon-left' : ''}
          ${inputAddonRightText ? 'ep-input--addon-right' : ''}
          ${inputIsDisabled ? 'ep-input--disabled' : ''}
          ${customClasses ? customClasses : ''}
        `}
        {...(!inputIsFullWidth && { style: { width: `${inputWidth}px` } })}
        {...(inputValue !== null &&
          inputValue !== undefined && { value: inputValue })}
      >
        {hasIcon && (
          <EpIcon iconName={inputIconName} iconSize={setIconSize(inputSize)} />
        )}

        <>
          {inputAddonLeftText && (
            <span className="ep-input__addon-txt">{inputAddonLeftText}</span>
          )}
          <input
            {...props}
            id={inputId}
            ref={ref}
            className={`ep-input__field`}
            type={inputType}
            name={inputName}
            {...(inputValue !== null &&
              inputValue !== undefined && { value: inputValue })}
            aria-describedby={inputAriaDescribedby}
            autoComplete={inputAutocomplete}
            placeholder={inputPlaceholder}
            disabled={inputIsDisabled ? true : false}
            min={inputMinValue}
            max={inputMaxValue}
            minLength={inputMinLength}
            maxLength={inputMaxLength}
            {...(!inputIsFullWidth && { style: { width: `${inputWidth}px` } })}
            onFocus={(e) => {
              handleInputFocus(e);
              {
                inputOnFocusFunc && inputOnFocusFunc(e);
              }
            }}
          />
          {inputAddonRightText && (
            <span className="ep-input__addon-txt">{inputAddonRightText}</span>
          )}
        </>
      </div>
    </div>
  );
});
